export default "__VITE_ASSET__liMxzDQ9__"